var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinanceCovenant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0V53H13.9068V51.037H7.96296V1.96296H45.2593V9.99541H47.2222V0H6Z",
    fill: "#146C94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2594 51.0368H19.0361V52.9998H47.2223V15.2422H45.2594V51.0368Z",
    fill: "#146C94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 7.85205H38.3888V9.81501H14.8333V7.85205Z",
    fill: "#19A7CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 23.5557H38.3888V25.5186H14.8333V23.5557Z",
    fill: "#19A7CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 15.7036H22.6851V17.6666H14.8333V15.7036Z",
    fill: "#19A7CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5371 15.7036H38.389V17.6666H30.5371V15.7036Z",
    fill: "#19A7CE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.38 43.4721L20.7222 40.8103C23.2076 39.7294 24.3462 36.8384 23.2654 34.353C22.1845 31.8675 19.2935 30.7289 16.808 31.8097C14.3226 32.8906 13.184 35.7817 14.2648 38.2671C14.7602 39.4061 15.669 40.3149 16.808 40.8103L14.1384 43.4721L15.5282 44.8618L18.7592 41.6288L21.9902 44.8618L23.38 43.4721ZM15.8147 36.3151C15.8147 34.6889 17.133 33.3707 18.7592 33.3707C20.3854 33.3707 21.7036 34.6889 21.7036 36.3151C21.7036 37.9413 20.3854 39.2596 18.7592 39.2596C17.133 39.2596 15.8147 37.9413 15.8147 36.3151C15.8147 36.3151 15.8147 36.3151 15.8147 36.3151Z",
    fill: "#19A7CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceCovenant);
export default __webpack_public_path__ + "static/media/finance-covenant.7b7b6a84bce459cfb48248b2a83935b7.svg";
export { ForwardRef as ReactComponent };